import { Attachment } from '../types';

export const isExternalReport = (attachment: Attachment) => {
    return !['dintero', 'payout'].includes(attachment.created_by || '');
};
